import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";
import { BreadCrumb } from "../../component/BreadCrumb";

import { RestroUserQueryLogsData } from "../../../../services/DatabaseService/RestroUserQueryLogs";
import CustomDataTable from "../../../../Components/CustomTable/CustomTable";
export default function RestroUserQueryLogs() {
  const [filterTenantCode, setFilterTenantCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [data, setData] = useState();
  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
        width: "max-content",
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };
  const fetchData = async (tenantCode = filterTenantCode) => {
    try {
      const result = await RestroUserQueryLogsData.getAll({
        tenantCode: tenantCode,
      });
      console.log("fired");
      setDataList(result.logs || []);
    } catch (error) {
      console.error("Failed to load data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [filterTenantCode]);

  const [filterText, setFilterText] = useState("");
  const [addModal, setAddModal] = useState(false);

  // const handleFilterChange = (e) => {
  //   setFilterText(e.target.value);
  // };

  const filteredData = Array.isArray(dataList)
    ? dataList.filter(
        (item) =>
          (item.name?.toLowerCase() || "").includes(
            filterText?.toLowerCase() || ""
          ) ||
          (item.database?.toLowerCase() || "").includes(
            filterText?.toLowerCase() || ""
          )
      )
    : [];

  const columns = [
    {
      name: "S No",

      selector: (row, index) => <div className="ps-2">{index + 1}</div>,
      sortable: true,
      width: "100px",
    },
    {
      name: "User Api Key",
      selector: (row) => (
        <span
          title={row.restroUsersInfoApiKey}
          className="d-block text-wrap text-break"
        >
          {}row.restroUsersInfoApiKey
        </span>
      ),
      sortable: true,
      width: "170px",
    },
    {
      name: "Tenant Code",
      selector: (row) => (
        <span title={row.tenantCode} className="d-block text-wrap text-break">
          {row.tenantCode}
        </span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Log For",
      selector: (row) => (
        <span title={row.logFor} className="d-block text-wrap tex-break">
          {row.logFor}
        </span>
      ),
      sortable: true,
      width: "170px",
    },
    {
      name: "Query Text",
      selector: (row) => row.queryText,
      sortable: true,
      width: "130px",
    },
    {
      name: "Response Status",
      selector: (row) => (
        <span className={`badge ${row.responseStatus ? "bg-success" : "bg-danger"}`}>
          {row.responseStatus ? "Success" : "Failed"}
        </span>
      ),
      sortable: true,
      width: "170px",
      // cell: (row) => (
      //   <button
      //     className={`btn btn-sm  ${
      //       row.responseStatus === "Success" ? "btn-success" : "btn-danger"
      //     }`}
      //     onClick={() => console.log("Button clicked for", row)}
      //   >
      //     {row.responseStatus === "Success" ? "Success" : "Failed"}
      //   </button>
      // ),
    },
    {
      name: "User Request",
      selector: (row) => ( <span className={`badge ${row.isActiveUserRequest ? "bg-success" : "bg-danger"}`}>
          {row.isActiveUserRequest ? "Active" : "InActive"}
        </span>),
      sortable: true,
      width: "170px",
      // cell: (row) => (
      //   <button
      //     className={`btn btn-sm ${
      //       row.isActiveUserRequest ? "btn-success" : "btn-danger"
      //     }`}
      //     onClick={() => console.log("Button clicked for", row)}
      //   >
      //     {row.isActiveUserRequest ? "Active" : "Inactive"}
      //   </button>
      // ),
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            // onClick={() => {
            //   setAddModal(true);
            //   // setSelectedCustomer(row);
            // }}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            // onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </div>
      ),
      center: true,
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Database List" pageTitle="Database" />
      </div>
      <Row>
        <Col className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by TenantCode"
              value={filterTenantCode}
              onChange={(e) => setFilterTenantCode(e.target.value)}
            />
          </InputGroup>
        </Col>
      </Row>
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                {/* <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                /> */}
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData || []}
          />
        </CardBody>
      </Card>
      {loading ? (
        <div className="my-5 d-flex justify-content-center">
          <h5 className="mt-1">Loading...</h5>
        </div>
      ) : (
        <>
          {filteredData?.map((item, index) => (
            <Card
              key={item.id || index}
              className="mb-3 shadow-sm d-block d-lg-none mt-2"
            >
              <CardBody>
                <Row>
                  <Col xs={10}>
                    <h6 className="mb-2">
                      <strong>S No:</strong> {index + 1}
                    </h6>
                    <h6 className="mb-2">
                      <strong>user Api Key:</strong>{" "}
                      {item.restroUsersInfoApiKey}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Tenant Code:</strong> {item.tenantCode}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Log For:</strong> {item.logFor}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Query Text:</strong> {item.queryText}
                    </h6>

                    <div className="d-flex flex-column gap-2 w-25">
                      {item.responseStatus === "Success" ? (
                        <button
                          className="btn btn-success px-1 px-sm-2"
                          onClick={() => setAddModal(true)}
                        >
                          Success
                        </button>
                      ) : (
                        <button
                          className="btn btn-danger px-1 px-sm-2"
                          onClick={() => setAddModal(true)}
                        >
                          Failed
                        </button>
                      )}

                      {item.isActiveUserRequest ? (
                        <button
                          className="btn btn-success px-1 px-sm-2"
                          onClick={() => setAddModal(true)}
                        >
                          Active
                        </button>
                      ) : (
                        <button
                          className="btn btn-danger px-1 px-sm-2"
                          onClick={() => setAddModal(true)}
                        >
                          Inactive
                        </button>
                      )}
                    </div>
                  </Col>

                  <Col xs={2}>
                    <div>
                      <Dropdown
                        isOpen={item.dropdownOpen || false}
                        toggle={(e) => {
                          e.stopPropagation();
                          setDataList((prev) =>
                            prev.map((dbItem) =>
                              dbItem.id === item.id
                                ? {
                                    ...dbItem,
                                    dropdownOpen: !dbItem.dropdownOpen,
                                  }
                                : { ...dbItem, dropdownOpen: false }
                            )
                          );
                        }}
                        direction="down"
                      >
                        <DropdownToggle
                          color="primary"
                          outline
                          className="btn-sm shadow-sm rounded-circle"
                        >
                          <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <DropdownItem
                            onClick={() => {
                              setAddModal(true);
                            }}
                          >
                            <i className="ri-edit-line text-warning me-2"></i>{" "}
                            Edit
                          </DropdownItem>
                          <DropdownItem>
                            <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </>
      )}
    </div>
  );
}
